import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom'
import AddButton from '../../components/buttons/AddButton'
import NavBreadCrumb from '../../containers/NavBreadCrumb'
import BaseList from '../../base/BaseList'
import axios from 'axios'
import { API_HOST } from '../../consts'
import AvaliacaoItem from './AvaliacaoItem'
import { fetchTemplates } from './services/template_service'
import FilterAtividades from '../../components/FilterAtividades'
import { get, debounce, filter } from 'lodash'
import { toast } from 'react-toastify'
import Loading from '../../components/Loading'
import queryString from 'query-string'
import ReactPaginate from 'react-paginate'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import {
  Typography, Tooltip
} from '@material-ui/core';
import Tour from 'reactour';
import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Steps from "../../contexts/StepReactTour/steps";
import { TrackGoogleAnalyticsEvent } from '../../utils/googleAnalytics';
import { ClickAllTrilhas, ClickAllTrilhasAction } from '../../utils/googleAnalytics/events/TrilhasAdaptativas/EventAllTrilhas';

import classnames from 'classnames';
import { Nav, NavItem, NavLink } from 'reactstrap';

import Alert from '@material-ui/lab/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';





class ListaAvaliacao extends BaseList {


  state = {
    data: [],
    templates: [],
    me: {},
    open: false,
    area_conhecimento: { value: '' },
    componente_curricular: { value: '' },
    exame: { value: '' },
    habilidades: { value: '' },
    matriz_referencia: { value: '' },
    curso: { value: '' },
    id: '',
    filters: [],
    filtersOnChange: [],
    paramsFilterAtividades: {},
    paramsFilterAtividadesOnChange: {},
    page: 1,
    page_size: 5,
    order_by: '-id',
    pramsFilter: {},
    searchFilter: "",
    filterVisibled: true,
    cleanStateFilter: false,
    isTourOpen: false,
    isOpen1: true,
    isOpen2: true,
    isOpen3: true,
  };

  api = `${API_HOST}/avaliacoes/avaliacao`;
  fetchDataCallback() {
    fetchTemplates().then((response) => {
      this.fetchMe()
      this.setState({
        templates: response
      })
    })
  };

  fetchMe() {
    const token = localStorage.getItem('token')
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data })
      })
      .catch((response) => {
        console.error(response.error)
      })
  };

  analytcsClick = (name, type) => {
    let label = "Click" + ": " + name;
    let category = ClickAllTrilhas + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickAllTrilhasAction,
      label,
    );
  };

  updateFilterBoxes = (values) => {

    const labels = {
      curso: "Segmento/Etapa",
      periodo: "Série/Ano",
      area_conhecimento: "Área do conhecimento",
      componente_curricular: "Componente curricular",
      matriz_referencia: "Matriz de referência",
      habilidade: "Habilidade",
      is_pae: 'PAE',
      is_processual:'Processual',
      avaliacao_oficial: 'Oficial SESI',
      id: "Código da Avaliação",
    };

    const boxes = Object.entries(values).map((entry) => {
      const field = entry[0];
      const value = entry[1];
      const box = { field, label: labels[field], valueLabel: this.state[field], value: value };

      return box;
    });

    const boxesWithValidValues = boxes.filter(d => d.value);

    this.setState({
      filters: boxesWithValidValues,
    });
    this.setState({
      paramsFilterAtividades: values,
    });


    if (this.state.filters.length > 0 && this.state.filterVisibled === false) {
      this.setState({ filterVisibled: true, cleanStateFilter: true });
    }
  };

  FilterData = debounce((loading = true) => {
    const { paramsFilterAtividadesOnChange } = this.state;

    this.updateFilterBoxes(paramsFilterAtividadesOnChange);

    let changePageFilter = {}
    for (var prop in paramsFilterAtividadesOnChange) {
      changePageFilter[prop] = paramsFilterAtividadesOnChange[prop]
    };
    for (var ini in this.state.pramsFilter) {
      changePageFilter[ini] = this.state.pramsFilter[ini]
    };

    this.setState({ open: false })
    this.setState({ page: 1 }, () => this.fetchData(loading, changePageFilter))
  }, 500);

  fetchData = async (loading = true, params) => {
    const { match } = this.props;
    const tipoId = match.params.id;

    let api = `${API_HOST}/avaliacoes/avaliacao?categoria=1`;

    if (tipoId) {
      api = `${API_HOST}/avaliacoes/avaliacao?categoria=${tipoId}`;
    }

    const { paramsFilterAtividades } = this.state;

    if (loading) {
      this.setState({ fetchingData: true });
    }


    return axios
      .get(api, {
        params: params ? params : paramsFilterAtividades || this.getParams()
      })
      .then((response) => {
        this.setState(
          {
            data: response.data.results,
            total: get(response, 'data.count', '-'),
            total_pages: get(response, 'data.total_pages', 0),
            fetchingData: false
          },
          () => {
            this.fetchDataCallback(response.data.results);
          }
        );
      })
      .catch((error) => {
        const status = get(error, 'response.status');
        if (status === 404) {
          const e = get(error, 'response.data.detail');
          toast.error(e);
        }

        this.setState({ fetchingData: false });
      });
  };

  removeConfirmationMessage = (selectedForRemovalId) => (
    `Tem certeza que deseja remover a avaliação ${selectedForRemovalId}?`
  );

  renderBreadcrumb = () => {
    const { isTourOpen } = this.state;
    const { match } = this.props;
    const tipoId = match.params.id;
    let currentPath = 'Avaliações';

    // Define o caminho com base no valor de tipoId
    switch (tipoId) {
      case '1':
        currentPath = 'Atividades Processuais';
        break;
      case '2':
        currentPath = 'Trilhas adaptativas';
        break;
      case '3':
        currentPath = 'Avaliações';
        break;
      default:
        currentPath = 'Avaliações';
        break;
    }

    return <NavBreadCrumb currentPath={currentPath} hasBackslash={false} />;
  };


  renderAddButton() {
    const { isTourOpen } = this.state;
    const { match } = this.props;
    const tipoId = match.params.id;

    if (tipoId === '1') {
      return null;
    }

    let buttonText = '';
    let urlTo = '';
    // Verifica o valor de tipoId e define o texto do botão de acordo
    switch (tipoId) {
      // case '1':
      //   buttonText = 'Criar trilha';
      //   break;
      case '2':
        buttonText = 'Criar avaliação com IA';
        urlTo = "/personal-create/6/avaliacao/new"

        break;
      case '3':
        buttonText = 'Criar atividade';
        urlTo = `/instrumentos-cognitivos/new/dados/tipo/${tipoId}`
        break;
      default:
        buttonText = 'Criar atividade';
        urlTo = `/instrumentos-cognitivos/new/dados/tipo/${tipoId}`
        break;
    }
    // const urlTo = `/instrumentos-cognitivos/new/dados/tipo/${tipoId}`

    return (
      <>
        <div data-tour="form-informacao2" >
          <Link to={urlTo} style={{ marginLeft: "-1rem" }}>
            <AddButton icon="plus" title={buttonText} />
          </Link>
        </div>
        <Tour
          steps={Steps}
          isOpen={isTourOpen}
          onRequestClose={() => this.setState({ isTourOpen: false })}
        />
      </ >
    );
  }


  renderCategoryFilter() {
    const { match, history } = this.props;
    const tipoId = match.params.id;

    return (
      <div className='container mb-3'>
        <Nav tabs fill>
          <NavItem>
            <NavLink
              className={classnames({
                active: tipoId === '3'
              })}
              style={{ cursor: "pointer" }}
              onClick={async () => {
                const s = "";
                await history.push('/instrumentos-cognitivos/tipo/3');
                this.setState({ search: "" });
                this.debouncedFetchData(s);
                this.fetchData();
              }}
            >
              Atividades Processuais
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: tipoId === '1'
              })}
              style={{ cursor: "pointer" }}
              onClick={async () => {
                const s = "";
                await history.push('/instrumentos-cognitivos/tipo/1');
                this.setState({ search: "" });
                this.debouncedFetchData(s);
                this.fetchData();
              }}
            >
              Trilhas Adaptativas
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: tipoId === '2'
              })}
              style={{ cursor: "pointer" }}
              onClick={async () => {
                const s = "";
                await history.push('/instrumentos-cognitivos/tipo/2');
                this.setState({ search: "" });
                this.debouncedFetchData(s);
                this.fetchData();
              }}
            >
              Avaliações
            </NavLink>
          </NavItem>
        </Nav>
      </div >
    )
  }

  renderFilters() {

    if (this.state.filters.length > 0 && this.state.filterVisibled) {
      return (
        <>
          {Object.values(this.state.filters).map((filter, index) => (
            <Tooltip
              title={filter.valueLabel}
              arrow
            >
              <button
                style={{ display: 'flex', maxWidth: '100%' }}
                key={`filter-${index}`}
                className="mr-1 mb-1 btn btn-white filter-box"
                onClick={() => {
                  if (filter.field != 'id') {
                    var changePageFilter = {}
                    for (var prop in this.state.paramsFilterAtividades) {
                      if (prop === filter.field) {
                        changePageFilter[prop] = ""
                      } else if (prop !== filter.field) {
                        changePageFilter[prop] = this.state.paramsFilterAtividades[prop]
                      };
                    };

                    this.setState({
                      [filter.field]: "",
                      paramsFilterAtividades: changePageFilter,
                      paramsFilterAtividadesOnChange: changePageFilter,
                      filtersOnChange: this.state.filters,
                    });
                  } else {
                    var changePageFilter = {}
                    for (var prop in this.state.paramsFilterAtividades) {
                      if (prop === filter.field) {
                        changePageFilter[prop] = ""
                      } else if (prop !== filter.field) {
                        changePageFilter[prop] = this.state.paramsFilterAtividades[prop]
                      };
                    };

                    this.setState({
                      [filter.field]: "",
                      paramsFilterAtividades: changePageFilter,
                      paramsFilterAtividadesOnChange: changePageFilter,
                      filtersOnChange: this.state.filters,
                    });
                  }

                  if (this.state.filters.length === 1) {
                    this.setState({ filterVisibled: false, cleanStateFilter: true })
                  }

                  this.FilterData();
                }}
              >
                <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <strong>{filter.label}: </strong>
                  {filter.valueLabel}
                </div>
                <i className="fas fa-times" style={{ fontSize: '18px', marginLeft: '0.5rem' }} />
              </button>

            </Tooltip>
          ))}

          <div className="row">
            <div className="col-2">
              <button
                className="btn btn-white mb-3"
                onClick={() => {
                  const loading = true

                  this.setState({ area_conhecimento: '' });
                  this.setState({ componente_curricular: '' });
                  this.setState({ exame: '' });
                  this.setState({ habilidades: '' });
                  this.setState({ matriz_referencia: '' });
                  this.setState({ curso: '' });
                  this.setState({ id: '' });
                  this.setState({ filters: [] });
                  this.setState({ filtersOnChange: [] });
                  this.setState({ filterVisibled: false });
                  this.setState({ cleanStateFilter: true });
                  var changePageFilter = {}
                  for (var prop in this.state.paramsFilterAtividades) {
                    changePageFilter[prop] = ""
                  };
                  this.setState({ paramsFilterAtividades: changePageFilter })
                  this.setState({ paramsFilterAtividadesOnChange: changePageFilter })
                  this.FilterData(loading, this.state.pramsFilter)
                }}
              >
                <i className="fas fa-eraser" /> Limpar todos os filtros
              </button>
            </div>
          </div>
        </>
      )
    }
  };

  handleOrderingChange = (value) => {
    var changePageFilter = {}
    const loading = true

    for (var prop in this.state.paramsFilterAtividades) {
      changePageFilter[prop] = this.state.paramsFilterAtividades[prop]
    };
    for (var key in value) {
      var label = "order_by"
      if (key !== "label") {
        changePageFilter[label] = value[key]
      }
    };

    this.setState({ order_by: get(value, 'value') })
    this.setState(this.fetchData(loading, changePageFilter))
  };

  renderOrderingSelect() {

    return (
      <UncontrolledDropdown>
        <DropdownToggle
          style={{
            width: '122px',
            height: '40px',
            padding: '8px 16px',
            background: "#E4E4E4",
            borderRadius: "24px",
            border: "none",
            outline: "none",
            textTransform: "capitalize",
            display: 'flex',
            alignItems: 'center'
          }}
          onClick={() => { this.analytcsClick('Ordenar', 'Button: Ordenar') }}
        >
          <Typography
            style={{
              fontFamily: 'Public Sans',
              fontSize: '16px',
              fontWeight: 700,
              lineheight: '24px',
              letterSpacing: '0em',
              textAlign: 'center',
              color: "#383838",
              display: 'flex',
              alignItems: 'center'
            }}
          >
            Ordenar
            <i style={{ marginLeft: '5px', color: "#383838", fontSize: '30px' }} className="icon-Arrow-tip-down" />
          </Typography>
        </DropdownToggle>
        <DropdownMenu style={{
          fontFamily: 'Public Sans',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '19px',
          letterSpacing: '0em',
          textAlign: 'left'
        }}>
          <DropdownItem onClick={() => {
            this.analytcsClick('Ordenar: Mais Recentes', 'Button: Ordenar');
            this.handleOrderingChange({ value: "-id", label: 'Mais Recentes' });
          }}>
            Mais recente
          </DropdownItem>
          <DropdownItem onClick={() => {
            this.analytcsClick('Ordenar: Mais antigo', 'Button: Ordenar');
            this.handleOrderingChange({ value: "id", label: 'Mais Antigos' })
          }}>
            Mais antigo
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>

    )
  };

  debouncedFetchData = debounce((search, loading = true) => {
    this.search = search
    var changePageFilter = {}
    for (var ini in this.state.pramsFilter) {
      if (ini === "search") {
        changePageFilter[ini] = search
      }
      else {
        changePageFilter[ini] = this.state.pramsFilter[ini]
      }
    };

    this.setState({ searchFilter: search })
    this.setState({ page: 1 }, () => this.fetchData(loading, changePageFilter))
  }, 500);

  renderToolbar() {
    const { search, tipoId } = this.state

    return (
      <div className="d-flex justify-content-between" style={{ marginBottom: (tipoId !== '3' ? '1rem' : 0) }}>
        <div className="d-flex" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="search mr-2" style={{ display: "flex", width: "430px", height: '35px', borderRadius: '40px', backgroundColor: '#E5E7EB', height: '40px' }}>
            <div style={{
              marginTop: '5px',
              marginLeft: '8px',
              width: '28px',
              height: '28px',
              borderRadius: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#ffff'
            }}>
              <i className='icon-Search-alt'>
              </i>
            </div>
            <input style={{ borderRadius: '40px', backgroundColor: '#E5E7EB', border: 'none', marginTop: '3px' }}
              className="search-term"
              placeholder="Pesquisar..."
              value={search}
              onBlur={(e) => {
                const label = e.target.value == '' ? 'Excluído' : e.target.value
                this.analytcsClick(`Pesquisar: ${label}`, 'Input: Search')
              }}
              onChange={(event) => {
                const s = event.target.value
                this.setState({ search: s })
                this.debouncedFetchData(s)
              }}
            />
          </div>
        </div>
        <div className="d-flex" style={{ marginRight: "1rem" }}>
          <div style={{ marginTop: "-2px" }}>
            <IconButton
              onClick={() => this.setState({ isTourOpen: true })}
            >
              <HelpOutlineIcon />
            </IconButton>
          </div>
          <div style={{ marginLeft: '0.5rem' }}>
            <>
              <div data-tour="form-informacao" >
                <button
                  className="btn" onClick={() => {
                    this.analytcsClick('Filtros', 'Filter All Trilhas');
                    this.setState({ open: true })
                  }}
                  style={{
                    marginRight: '0.5rem',
                    fontFamily: 'Public Sans',
                    fontSize: '16px',
                    fontWeight: 700,
                    lineHeight: '24px',
                    letterSpacing: '0em',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px, 0px, 8px, 0px',
                    borderRadius: '24px',
                    border: 'none',
                    height: '40px',
                    background: "#E4E4E4",
                  }}>
                  <i
                    class="icon-Filter"
                    aria-hidden="true"
                    style={{
                      marginRight: '6px',
                      fontSize: '24px',
                      fontWeight: 400,
                      lineHeight: '24px',
                      letterSpacing: '0em',
                      textAlign: 'center',
                    }}
                  />
                  Filtros
                </button>
              </div>
            </>
            <FilterAtividades
              filters={this.state.paramsFilterAtividades}
              filtersOnChange={this.state.paramsFilterAtividadesOnChange}
              cleanState={this.state.cleanStateFilter}
              open={this.state.open}
              handleClose={() => {
                let changeFilter = {}
                for (var prop in this.state.filters) {
                  changeFilter[this.state.filters[prop].field] = this.state.filters[prop].value
                };

                this.setState({
                  paramsFilterAtividadesOnChange: changeFilter,
                  paramsFilterAtividades: changeFilter,
                  open: false,
                });
              }}
              onChange={(e, name) => {
                let copyParams = this.state.paramsFilterAtividadesOnChange
                if (e && e.value) {
                  copyParams[name] = e && e.value;
                  if(copyParams['tipo_avaliacao'] == 3){
                    copyParams = { ...copyParams, is_processual: 1 };
                    delete copyParams.tipo_avaliacao;
                  }
                  if(copyParams['tipo_avaliacao'] == 2){
                    copyParams = { ...copyParams, avaliacao_oficial: 1 };
                    delete copyParams.tipo_avaliacao; 
                  }
                  if(copyParams['tipo_avaliacao'] == 1){
                    copyParams = { ...copyParams, is_pae: 1 };
                    delete copyParams.tipo_avaliacao; 
                  }

                  if (name === "curso") {
                    copyParams["periodo"] = "";
                    copyParams["matriz_referencia"] = "";
                    copyParams["habilidades"] = "";

                    if (e.value == 6 || e.value == 10) {
                      copyParams["componente_curricular"] = "";
                    }
                  }
                  else if (name === "area_conhecimento") {
                    copyParams["componente_curricular"] = "";
                    copyParams["matriz_referencia"] = "";
                    copyParams["habilidades"] = "";

                  }
                  else if (name === "matriz_referencia") {
                    copyParams["habilidades"] = "";
                  }
                }
                else if (e) {
                  copyParams[name] = e
                }
                else if (name && !e) {
                  copyParams[name] = e
                }

                this.setState({ paramsFilterAtividadesOnChange: copyParams });

                if (e) {
                  if (e.value) {
                    this.setState({ [name]: e.label });
                    switch (name) {
                      case "curso": {
                        this.setState({ periodo: "", });

                        if (e.value == 6 || e.value == 10) {
                          this.setState({ componente_curricular: "" });
                          this.setState({ matriz_referencia: "" });
                          this.setState({ habilidade: "" });
                        }
                      }
                      case "area_conhecimento": {
                        this.setState({ componente_curricular: "" });
                        this.setState({ matriz_referencia: "" });
                        this.setState({ habilidade: "" });
                      }
                      case "matriz_referencia": {
                        this.setState({ habilidade: "" });
                      }
                      default: {
                        return (<></>);
                      }
                    }
                  }
                  else {
                    this.setState({ [name]: e });
                    switch (name) {
                      case "curso": {
                        this.setState({ periodo: "", });

                        if (e.value == 6 || e.value == 10) {
                          this.setState({ componente_curricular: "" });
                          this.setState({ matriz_referencia: "" });
                          this.setState({ habilidade: "" });
                        }
                      }
                      case "area_conhecimento": {
                        this.setState({ componente_curricular: "" });
                        this.setState({ matriz_referencia: "" });
                        this.setState({ habilidade: "" });
                      }
                      case "matriz_referencia": {
                        this.setState({ habilidade: "" });
                      }
                      default: {
                        return (<></>);
                      }
                    }
                  }
                }
                else {
                  this.setState({ [name]: "" })
                }
              }}
              search={this.FilterData}
            />
          </div>
          {this.renderOrderingSelect()}
          {this.renderAddButton()}
        </div>
      </div>
    )
  };

  handleRemove = (id) => {
    this.setState({
      selectedForRemovalId: id,
      openModal: 'removeConfirmation',
      typeModal: 'avaliacao'
    })
  };

  handleCloseAlert = (alertNumber) => {
    this.setState({ [`isOpen${alertNumber}`]: false });
  };


  renderList() {
    const { match } = this.props;
    const tipoId = match.params.id;
    const { data, templates, fetchingData } = this.state
    const { isOpen1, isOpen2, isOpen3 } = this.state;

    if (fetchingData) {
      return (
        <Loading />
      )
    }

    return (
      <>
        {tipoId === '1' && isOpen1 && (
          <div style={{ width: '100%', marginRight: 'auto' }}>
            <Alert severity="info" onClick={() => this.handleCloseAlert(1)}>
              Instrumentos desenvolvidos por especialistas com o objetivo de desenvolver competências e habilidades
              da Matriz SESI consideradas críticas, conforme mapeadas no PASSE. Estas trilhas são automaticamente direcionadas aos
              estudantes por intermédio de um sistema adaptativo. Para aplicar uma trilha de maneira manual, é possível criar uma cópia
              e acessá-la na seção 'Atividades Processuais'.
            </Alert>
          </div>
        )}
        {tipoId === '2' && isOpen2 && (
          <div style={{ width: '100%', marginRight: 'auto' }}>
            <Alert severity="info" onClick={() => this.handleCloseAlert(2)}>
              Seção reservada para as avaliações que integram o PASSE e os PPIs.
            </Alert>
          </div>
        )}
        {tipoId === '3' && isOpen3 && (
          <div style={{ width: '100%', display: 'auto' }}>
            <Alert severity="info" onClick={() => this.handleCloseAlert(3)} style={{ flex: 1, marginRight: '10px' }}>
              Seção destinada à criação de atividades diagnósticas, formativas e somativas
            </Alert>
          </div>
        )}
        <div style={{ marginTop: '10px' }}>
          {data.map((avaliacao, indice) => (
            <AvaliacaoItem
              key={avaliacao.id}
              keyTooltip={indice}
              avaliacao={avaliacao}
              tipoId={tipoId}
              categoria={this.handleCategory(tipoId)}
              onRemove={this.handleRemove}
              onCopy={this.handleCopy}
              templates={templates}
              me={this.state.me}
              userId={this.props.user.id}
              permissions={this.props.permissions}
            />
          ))}
        </div>
      </>
    );
  };

  handleCategory = (tipoId) => {
    switch (tipoId) {
      case '1':
        return 'trilha';
      case '2':
        return 'avaliação';
      case '3':
        return 'atividade';
      default:
        return 'avaliação';
    }
  }

  changePage = (pagination) => {
    // const { location, history, } = this.props

    const page = pagination.selected + 1
    const pageObj = { page: pagination.selected + 1 }
    const pageSizeObj = { page_size: this.state.page_size }
    const loading = true

    this.setState({ fetchingData: true })

    var changePageFilter = {}
    for (var prop in this.state.paramsFilterAtividades) {
      changePageFilter[prop] = this.state.paramsFilterAtividades[prop]
    };
    for (var key in pageObj) {
      changePageFilter[key] = pageObj[key]
    };
    for (var propPageSize in pageSizeObj) {
      changePageFilter[propPageSize] = pageSizeObj[propPageSize]
    };
    for (var ini in this.state.pramsFilter) {
      if (ini !== "page") {
        if (ini === "search" && this.state.searchFilter) {
          changePageFilter[ini] = this.state.searchFilter
        } else {
          changePageFilter[ini] = this.state.pramsFilter[ini]
        }
      }
    };

    this.setState({ page }, () => this.fetchData(loading, changePageFilter))

    // const search = queryString.stringify( {
    //   ...queryString.parse( location.search ),
    //   page,
    // } )
    // history.push(`${location.pathname}?${search}`)
  };

  handlePageSizeChange = (value) => {
    this.setState(
      {
        page_size: get(value, 'value'),
        page: 1
      },
    )

    const pageSizeObj = { page_size: get(value, 'value') }
    const loading = true

    var changePageFilter = {}
    for (var prop in this.state.paramsFilterAtividades) {
      changePageFilter[prop] = this.state.paramsFilterAtividades[prop]
    };
    for (var key in pageSizeObj) {
      changePageFilter[key] = pageSizeObj[key]
    };
    for (var ini in this.state.pramsFilter) {
      changePageFilter[ini] = this.state.pramsFilter[ini]
    };

    this.setState(this.fetchData(loading, changePageFilter))
  };



  renderPagination() {
    const { page, data, total_pages, fetchingData, total } = this.state

    if (fetchingData) {
      return null
    };

    if (data.length > 0) {
      return (
        <div className="row" style={{ textAlign: 'center' }}>
          <div className="col-md-3">
            {/* <Select
              matchPos="auto"
              className="filter-size"
              value={page_size}
              options={this.paginationOptions}
              clearable={false}
              onChange={(e) => (this.handlePageSizeChange(e))}
              searchable={false}
            /> */}
          </div>
          <div className="col-md-3 col-lg-3 col-xs-3" style={{ fontSize: 12 }}>
            <p style={{ marginBottom: 5, marginTop: 10 }}>
              Mostrando <b>{data.length}</b> de <b>{total}</b> registros
            </p>
          </div>
          <div className="col-6">
            <ReactPaginate
              pageCount={total_pages}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              previousLabel="ANTERIOR"
              nextLabel="PRÓXIMA"
              onPageChange={pagination => { this.changePage(pagination) }}
              initialSelected={page}
              forcePage={page - 1}
              containerClassName="pagination"
              activeClassName="active"
              disabledClassName="disabled"
              disableInitialCallback
              breakLabel={<button className="disabled">. . .</button>}
            />
          </div>
        </div>

      )
    };

    return null
  };

  componentDidMount() {
    const { page, page_size, order_by } = this.state
    const loading = true
    const initialProps = {
      page,
      page_size,
      search: this.search,
      order_by,
    }
    this.fetchMe()
    const { location } = this.props
    const search = queryString.parse(location.search)
    if (search.id) {
      this.params = {
        id: search.id,
        ...this.params,
      }
    }
    if (search.page) {
      this.setState({ page: search.page }, this.fetchData)
    } else {
      this.fetchData(loading, initialProps)
      this.setState({ pramsFilter: initialProps })
    }
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('Modal') === 'True') {
      this.setState({ open: true })
    }
  };


  render() {

    return (
      <div>
        {this.renderCategoryFilter()}
        {/* {this.renderBreadcrumb()} */}
        <div className="container">
          {this.renderToolbar()}
          {this.renderFilters()}
          {this.renderList()}
          {this.renderPagination()}
        </div>
        {this.renderRemoveConfirmationModal()}
      </div>
    )
  };

};

export default withRouter(ListaAvaliacao)
